import classnames from 'classnames';

interface MenuShelfConfigurationEntryProps {
	readonly additionalClass: string;
	readonly shelfPart: string;
	readonly handleClick: () => void;
}

export const MenuShelfConfigurationEntry = (props: MenuShelfConfigurationEntryProps) => {
	return (
			<label
					className={classnames({
						"relative block select-none rounded-lg border border-gray-300 bg-white shadow-sm px-4 py-4 cursor-pointer hover:border-gray-400 sm:justify-between focus-within:ring-1 focus-within:ring-offset-2 focus-within:ring-blue-500 hidden style-button style-button-back": true,
						[props.additionalClass]: true
					})}>
				<input onClick={() => props.handleClick()}
				       type="checkbox"
				       name="server_size"
				       value="Hobby"
				       className="sr-only"
				       aria-labelledby="server-size-0-label"
				       aria-describedby="server-size-0-description-0 server-size-0-description-1"/>
				<div className="w-full flex items-center">
					<div className="w-full text-sm justify-items-stretch">
						<div className="style-button-text font-medium text-gray-900">{props.shelfPart}</div>
						<div className="text-gray-500 text-right"></div>
					</div>
				</div>
				<div className="toggle border-transparent absolute -inset-px rounded-lg border-4 pointer-events-none"
				     aria-hidden="true"></div>
			</label>
	);
};
